import {FC, Fragment, PropsWithChildren} from "react";
import {Modal, ModalContent, ModalInner, Overlay} from "./common";
import {ReactComponent as CloseIcon} from "assets/images/icons/close.svg";
import {CloseButton} from "components/Buttons";

interface IBaseModal {
	handleClose?: () => void;
	className?: string;
	overlayClassName?: string;
}

export const BaseModal: FC<PropsWithChildren<IBaseModal>> = ({
	handleClose,
	children,
	className,
	overlayClassName,
}) => {
	return (
		<Fragment>
			<Overlay onClick={handleClose} className={overlayClassName} />
			<Modal className={className}>
				<ModalInner className="modal-inner">
					<ModalContent>
						{handleClose && (
							<CloseButton onClick={handleClose}>
								<CloseIcon />
							</CloseButton>
						)}

						{children}
					</ModalContent>
				</ModalInner>
			</Modal>
		</Fragment>
	);
};
